import { axiosInstance } from '../axios';

export const cacheApi = {
  clearAll: () => axiosInstance.delete('/v1/product-admin/cache'),
  clearInstitute: (id: number) => axiosInstance.delete(`/v1/product-admin/cache/institute/${id}`),
  clearUser: (userId: string) => axiosInstance.delete(`/v1/product-admin/cache/user/${userId}`),
};
